import Vue from 'vue';
import { store } from "../src/store";
import { is_it_client_reliance_type } from "@/backend/axios/organisation_config.js";

// Function to replace text in a given node
function replaceTextInNode(node, organizationName) {
  if (is_it_client_reliance_type()) {
    let text = node.textContent;

    const replacements = [
      [/\bSub-Location\b|\bSub Location\b/g, 'Bin Location'],
      [/\bSublocations\b|\bSub-Locations\b/g, 'Bin Locations'],
      [/\bArticle Id\b|\bArticle ID\b/g, 'Article Code'],
      [/\bScan Indicator\b/g, 'Serial Profile'],
      [/\bASP\b/g, 'RRP'],
      [/\bCategory Code\b/g, 'MCH Code'],
      [/\bCategory L1\b|\bCategory Node 1\b/g, 'Segment'],
      [/\bCategory L2\b|\bCategory Node 2\b/g, 'Class'],
      [/\bCategory L3\b|\bCategory Node 3\b/g, 'Family'],
      [/\bCategory L4\b|\bCategory Node 4\b/g, 'Description'],
      [/\bSerial Number 1\b|\bSerial No.1\b|\bS No. 1\b/g, 'Box Serial Number'],
      // [/\bPurchase Vendor\b/g, 'Vendor'],
      [/\bPurchase Location\b/g, 'Receiving DC'],
      // [/\bReturn Reason\b/g, 'Nature Of Problem'],
      [/\bReturn Sub-Reason\b/g, 'Type Of Defect'],
      [/\bReturn Request Type\b/g, 'Return Type'],
      [/\bSerial Number 2\b|\bSerial No.2\b|\bS No. 2\b/g, 'Product Serial Number'],
      [/\bComplete IRD\b/g, 'Save Scanned Item'],
      [/\bInwarded Date\b/g, 'Scanned Date'],
    ];

    for (const [regex, replacement] of replacements) {
      text = text.replace(regex, replacement);
    }

    node.textContent = text;
  }
}

// Function to replace text globally in all text nodes
function replaceTextGlobally() {
  const organizationName = store.state.organization_name;

  if (is_it_client_reliance_type()) {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    while ((node = walker.nextNode())) {
      replaceTextInNode(node, organizationName);
    }
  }
}

// Observe DOM changes and reapply text replacement
function observeDOMChanges() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            replaceTextInNode(node, store.state.organization_name);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            const walker = document.createTreeWalker(
              node,
              NodeFilter.SHOW_TEXT,
              null,
              false
            );

            let childNode;
            while ((childNode = walker.nextNode())) {
              replaceTextInNode(childNode, store.state.organization_name);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Initialize label changes
export function initializeLabelChanges(app) {
  replaceTextGlobally();
  observeDOMChanges();

  app.config.globalProperties.$triggerTextReplacement = replaceTextGlobally;
}
